import { Component } from "@angular/core";

import { NavParams, MenuController, NavController } from "ionic-angular";
import { APIServiceProvider } from "../../../common/services/api.service";

import { InventoryDetailsStockPage } from "../inventorydetailsstock/inventorydetailsstock";
import { InventoryDetailsProcurementPage } from "../inventorydetailsprocurement/inventorydetailsprocurement";
import { InventoryDetailsOrdersPage } from "../inventorydetailsorders/inventorydetailsorders";
import { InventoryDetailsService } from "../inventorydetails.service";

@Component({
  selector: "tabs-inventorydetails",
  templateUrl: "tabs-inventorydetails.html"
})
export class TabInventoryDetails {
  // set the root pages for each tab
  ipstocktransfer = InventoryDetailsStockPage;
  iporders = InventoryDetailsOrdersPage;
  ipprocurement = InventoryDetailsProcurementPage;
  public inventoryDetails = {};

  mySelectedIndex: number = 0;

  constructor(
    navParams: NavParams,
    public menu: MenuController,
    public navCtrl: NavController,
    public apiService: APIServiceProvider,
    private inventoryDetailsService: InventoryDetailsService
  ) {
    this.inventoryDetails = this.inventoryDetailsService.inventory;
  }

  public inventoryCounts: any = {
    st: 0,
    order: 0,
    procurement: 0
  };

  ionViewDidLoad() {
    this.menu.enable(true);
    const postParams = {
      product_id: this.inventoryDetails["product_id"],
      manager_id: localStorage.getItem("manager_user_id")
    };
    this.apiService
      .post("inventory/get-inventory-details-count", postParams)
      .subscribe(response => {
        this.inventoryCounts.st = response["data"]["stock_transfer"];
        this.inventoryCounts.order = response["data"]["order"];
        this.inventoryCounts.procurement = response["data"]["inward"];
      });
  }
}



// WEBPACK FOOTER //
// ./src/pages/inventory/inventorydetailstabs/tabs-inventorydetails.ts